import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACK_END_URL
});

axiosInstance.defaults.timeout = 50000;

export default axiosInstance;
